import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithReauth } from './baseQueryWithReauth';

export interface FinanceTotals {
  totalRevenue: number;
  totalExpenses: number;
  netProfit: number;
  totalAmount: number;
  totalTransactions: number;
}

export interface CurrencyRates {
  base: string;
  rates: Record<string, number>;
  timestamp: number;
}

export const financeApi = createApi({
  reducerPath: 'financeApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getReport: builder.query<{ totals: FinanceTotals }, void>({
      query: () => ({ url: '/finance/report' }),
    }),
    getCurrencyRates: builder.query<CurrencyRates, string | void>({
      query: (base = 'USD') => ({ url: `/finance/currency?base=${base}` }),
    }),
  }),
});

export const { useGetReportQuery, useGetCurrencyRatesQuery } = financeApi;
